import { Styles } from '@monkvision/types';

export const styles: Styles = {
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
};
